import { AlignJustifyIcon, FileTextIcon, Grid2X2Icon, NetworkIcon, SettingsIcon } from 'lucide-react';

import { useGlobalAuthStore } from '@Stores/global/auth';
import AppSidebar from 'components/app-layout/Sidebar';
import AppSidebarItem from 'components/app-layout/SidebarItem';

export default function OfferSidebar() {
  const { auth: { isSuperAdmin } } = useGlobalAuthStore()
  return <AppSidebar>
    <AppSidebarItem
      to='/offer/offers'
      icon={FileTextIcon}
      alias='Offers'
    />
    <AppSidebarItem
      to='/offer/publishers'
      icon={NetworkIcon}
      alias='Publishers'
    />
    <AppSidebarItem
      to='/offer/allocations'
      icon={Grid2X2Icon}
      alias='Allocations'
    />
    <AppSidebarItem
      to='/offer/forms'
      icon={AlignJustifyIcon}
      alias='Forms'
    />
    {isSuperAdmin && <AppSidebarItem
      to='/offer/settings'
      icon={SettingsIcon}
      alias='Settings'
    />
    }
  </AppSidebar>
}
